import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';

@Injectable()
export class ToolbarEvent {
    private toolBarEvent: Subject<ToolbarEventArg>;
    constructor() {
        this.toolBarEvent = new Subject<ToolbarEventArg>();
    }

    async boardcast(key: string,value?:any) {
        const arg: ToolbarEventArg = <ToolbarEventArg>{};
        arg.key = key;
        arg.value = value;
        await this.toolBarEvent.next(arg);
    }

    click(): Observable<ToolbarEventArg> {
        return this.toolBarEvent.asObservable();
    }
}

export interface ToolbarEventArg {
    key: string,
    value:any
}


// WEBPACK FOOTER //
// ./src/app/core/events/toolbar.event.ts